import React, { useEffect, useState } from "react"
import EnrollmentCompletionChart from "../../../components/ui/EnrollmentCompletionChart"
import { computeEnrollmentCompletionSeries } from "../../../utils/enrollmentCompletionHelpers"

// This card's time range (24H–1Y) is independent of the dashboard's global
// date filter, since the granularities don't overlap (hourly/monthly vs the
// dashboard's 7d/30d/90d/12m) — so it manages its own range state and
// refetches whenever the range changes.
const EnrollmentCompletionSection = ({ orgId }) => {
  const [range, setRange] = useState("1w")
  const [buckets, setBuckets] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!orgId) return
    let cancelled = false
    setLoading(true)
    computeEnrollmentCompletionSeries(orgId, range).then((data) => {
      if (!cancelled) {
        setBuckets(data)
        setLoading(false)
      }
    })
    return () => {
      cancelled = true
    }
  }, [orgId, range])

  return <EnrollmentCompletionChart buckets={buckets} loading={loading} range={range} onRangeChange={setRange} />
}

export default EnrollmentCompletionSection